export default __webpack_public_path__ + "static/media/waterdrop.a8932334.webp";